import React from "react";
import { CheckCircle2, Wrench, ShieldCheck, Timer, Award } from "lucide-react";
import { ABOUT } from "@/constants/testIds";

const points = [
  { icon: ShieldCheck, title: "Licensed & Insured", body: "Every job pulled, inspected, and signed off to current electrical code." },
  { icon: Wrench, title: "Tradesmen, Not Salesmen", body: "You speak directly with the electricians doing the work — no call-centre middlemen." },
  { icon: Timer, title: "On-Time, On-Estimate", body: "Quotes are firm. Schedules are honoured. Your time is respected." },
  { icon: Award, title: "Built To Last", body: "Quality breakers, copper conductors, neatly bundled — work we'd want behind our own walls." },
];

export default function About() {
  return (
    <section id="about" data-testid={ABOUT.root} className="pe-section">
      <div className="container-pe">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="pe-eyebrow mb-5">About Perez Electric</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]">
              SMALL SHOP.
              <br />
              <span className="text-[var(--pe-gold)]">BIG STANDARDS.</span>
            </h2>
            <p className="mt-6 text-[var(--pe-muted)] leading-relaxed">
              Perez Electric is a team of hands-on electrical contractors
              serving residential and commercial clients. From a single
              device replacement to a full commercial fit-up, every project
              is executed with the same disciplined approach: code-compliant
              installations, methodical workmanship, thorough documentation,
              and a clean, professional finish.
            </p>
            <p className="mt-4 text-[var(--pe-muted)] leading-relaxed">
              From EV charger installations to new construction, our crew
              delivers electrical work built to pass inspection, perform
              reliably for the long term, and reflect the standards we'd
              hold in our own homes.
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {["Code-compliant", "Permit-pulled", "Tidy installs", "Up-front pricing", "Warrantied work"].map((t) => (
                <span key={t} className="font-mono text-[10px] tracking-[0.22em] uppercase px-3 py-2 border border-[var(--pe-line-strong)] text-[var(--pe-muted)]">
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {points.map((p) => (
              <div key={p.title} className="pe-card">
                <p.icon className="h-6 w-6 text-[var(--pe-gold)]" />
                <h3 className="font-display text-xl mt-4 text-white tracking-wide">
                  {p.title.toUpperCase()}
                </h3>
                <p className="mt-2 text-sm text-[var(--pe-muted)] leading-relaxed">{p.body}</p>
              </div>
            ))}

            <div className="pe-card sm:col-span-2 bg-[var(--pe-ink)]">
              <h3 className="font-display text-xl tracking-wide text-white">CRAFTSMANSHIP, GUARANTEED</h3>
              <p className="mt-2 text-sm text-[var(--pe-muted)] leading-relaxed">
                Every install is backed by workmanship warranty and signed
                off to current electrical code. Quality breakers, copper
                conductors, labelled circuits — the kind of work that holds
                up to inspection and to time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
